/**
 * TODO: Drive this through the build so loaded config can be parameterized
 */

import config from "./default";

export default config;



